import React from 'react';

import chip from '../../../../assets/chip.png';

import styles from './Chip.scss';

const Chip: React.FC = () => (
  <div className={styles.root}>
    <picture>
      <img src={chip} alt="Logo" className={styles.image} />
    </picture>
  </div>
);

export default Chip;
